import React, { useState, useRef, useEffect } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import auth from "./firebase";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import imgCover from "./004.jpg";
import imgCharacter from "./Sin título.png";


const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [remember, setRemember] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', isError: false });
  const [isLoading, setIsLoading] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    // Cargar datos guardados si existe "remember me"
    const savedUser = localStorage.getItem('noctra_user');
    if (savedUser) {
      setFormData(prev => ({ ...prev, username: savedUser }));
      setRemember(true);
      showToast('Bienvenido de nuevo', false);
    }
  }, []);

  const showToast = (message, isError = false) => {
    setToast({ show: true, message, isError });
    setTimeout(() => {
      setToast({ show: false, message: '', isError: false });
    }, 3000);
  };

  const handleMouseMove = (e) => {
    if (cardRef.current) {
      const rect = cardRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      cardRef.current.style.setProperty('--x', `${x}px`);
      cardRef.current.style.setProperty('--y', `${y}px`);
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const { username, password } = formData;

  if (username.length === 0) {
    showToast('Ingresa tu usuario o correo', true);
    return;
  }

  if (password.length === 0) {
    showToast('Ingresa tu contraseña', true);
    return;
  }

  try {

    setIsLoading(true);

    await signInWithEmailAndPassword(
      auth,
      username,
      password
    );

    if (remember) {
      localStorage.setItem('noctra_user', username);
    } else {
      localStorage.removeItem('noctra_user');
    }

    showToast(`¡Bienvenido de vuelta!`, false);

    setTimeout(() => {
      navigate("/");
    }, 1000);

  } catch (error) {

    console.log(error);

    showToast("Correo o contraseña incorrectos", true);

  } finally {

    setIsLoading(false);

  }
};

  const handleSocialLogin = (provider) => {
    showToast(`Redirigiendo a ${provider}...`, false);
    console.log(`Login con ${provider}`);
  };

  const handleForgotPassword = (e) => {
    e.preventDefault();
    showToast('Enviamos un enlace a tu correo', false);
    console.log('Recuperar contraseña');
  };

  const handleSignup = (e) => {
    e.preventDefault();
    showToast('Redirigiendo a registro...', false);
    console.log('Ir a registro');
  };

  return (
    <div className="login-container">
      <div className="bg"></div>
      <div className="overlay"></div>
      <div className="glow"></div>

     <div className="wrapper">

  {/* LOGIN IZQUIERDA */}
  <div
    className="card"
    ref={cardRef}
    onMouseMove={handleMouseMove}
  >

    <div className="top">
      <div className="logo">TMOXNight</div>
      <div className="sub">WELCOME BACK · 18+</div>
    </div>

    <form onSubmit={handleSubmit}>

      <div className="group">
        <input
          type="text"
          className="input"
          id="username"
          placeholder=" "
          required
          value={formData.username}
          onChange={handleChange}
        />

        <label className="label">
          Usuario o correo electrónico
        </label>
      </div>

      <div className="group">
        <input
          type="password"
          className="input"
          id="password"
          placeholder=" "
          required
          value={formData.password}
          onChange={handleChange}
        />

        <label className="label">
          Contraseña
        </label>
      </div>

      <div className="options">

        <label className="remember">
          <input
            type="checkbox"
            checked={remember}
            onChange={(e) => setRemember(e.target.checked)}
          />
          Recordarme
        </label>

        <a href="#" className="forgot" onClick={handleForgotPassword}>
          ¿Olvidaste tu contraseña?
        </a>

      </div>

      <button
        className={`btn ${isLoading ? 'loading' : ''}`}
        type="submit"
        disabled={isLoading}
      >
        {isLoading ? '' : 'INICIAR SESIÓN'}
      </button>

    </form>

    <div className="divider">
      <span>O CONTINÚA CON</span>
    </div>

    <div className="bottom">
      ¿No tienes cuenta?
      <a href="#" onClick={handleSignup}>
        Crear cuenta
      </a>
    </div>

  </div>

  {/* TARJETA 3D DERECHA */}
<div className="card3d">
  <div className="wrapper3d">
    <img src={imgCover} className="cover-image" alt="" />
  </div>

  <img src={imgCharacter} className="character" alt="" />
</div></div>

      <div className={`toast ${toast.show ? 'show' : ''} ${toast.isError ? 'error' : ''}`}>
        {toast.message}
      </div>
    </div>
  );
};

export default Login;